// migrated 1:1 from @nexato/nx-core-module, #688
import { Label } from "../../../entities/label/label";
import { Activity } from "../../../entities/activity/activity";
import { ActivityComponent } from "./activityComponent";
import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-labels-updated',
  template: `
    <ng-container *ngIf="activity()?.viewModel as vm">
      <b>{{ activity()?.actor?.displayName }}</b> hat
      <ng-container *ngIf="addedLabels()?.length">
        <ng-container *ngIf="addedLabels().length === 1">
          das Label <app-label [label]="addedLabels()[0]"></app-label> hinzugefügt
        </ng-container>
        <ng-container *ngIf="addedLabels().length === 2">
          die Labels <app-label [label]="addedLabels()[0]"></app-label> und <app-label [label]="addedLabels()[1]"></app-label> hinzugefügt
        </ng-container>
        <ng-container *ngIf="addedLabels().length > 2">
          die Labels
          <ng-container *ngFor="let label of addedLabels(); let i = index">
            <ng-container *ngIf="i < addedLabels().length - 2">
              <app-label [label]="label"></app-label>,
            </ng-container>
            <ng-container *ngIf="i === addedLabels().length - 2">
              <app-label [label]="label"></app-label> und
            </ng-container>
            <ng-container *ngIf="i === addedLabels().length - 1">
              <app-label [label]="label"></app-label>
            </ng-container>
          </ng-container>
          hinzugefügt
        </ng-container>
      </ng-container>
      <ng-container *ngIf="addedLabels()?.length && removedLabels()?.length">
        und
      </ng-container>
      <ng-container *ngIf="removedLabels()?.length">
        <ng-container *ngIf="removedLabels().length === 1">
          das Label <app-label [label]="removedLabels()[0]"></app-label> entfernt
        </ng-container>
        <ng-container *ngIf="removedLabels().length === 2">
          die Labels <app-label [label]="removedLabels()[0]"></app-label> und <app-label [label]="removedLabels()[1]"></app-label> entfernt
        </ng-container>
        <ng-container *ngIf="removedLabels().length > 2">
          die Labels
          <ng-container *ngFor="let label of removedLabels(); let i = index">
            <ng-container *ngIf="i < removedLabels().length - 2">
              <app-label [label]="label"></app-label>,
            </ng-container>
            <ng-container *ngIf="i === removedLabels().length - 2">
              <app-label [label]="label"></app-label> und
            </ng-container>
            <ng-container *ngIf="i === removedLabels().length - 1">
              <app-label [label]="label"></app-label>
            </ng-container>
          </ng-container>
          entfernt
        </ng-container>
      </ng-container>
      <app-relative-time [timestamp]="activity()?.createdDateTime" />
    </ng-container>
  `
})
export class LabelsUpdatedComponent implements ActivityComponent {

  readonly activity = input.required<Activity>();
  readonly ownerId = input<string>();

  readonly removedLabels = computed(() => {
    const activity = this.activity();
    if (activity?.viewModel) {
      return Label.createLabels(activity.viewModel.removedLabels) || [];
    }
    return [];
  });

  readonly addedLabels = computed(() => {
    const activity = this.activity();
    if (activity?.viewModel) {
      return Label.createLabels(activity.viewModel.addedLabels) || [];
    }
    return [];
  });

  // Die Logik für die Label-Text-Darstellung ist jetzt im Template umgesetzt
}
